/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Preset_Manager_Delete_Success_ToastInputs */

const en_preset_manager_delete_success_toast = /** @type {(inputs: Preset_Manager_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preset "${i?.name}" deleted successfully`)
};

const fr_preset_manager_delete_success_toast = /** @type {(inputs: Preset_Manager_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preset "${i?.name}" supprime avec succes`)
};

const de_preset_manager_delete_success_toast = /** @type {(inputs: Preset_Manager_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voreinstellung "${i?.name}" erfolgreich gelöscht`)
};

const it_preset_manager_delete_success_toast = /** @type {(inputs: Preset_Manager_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preimpostazione "${i?.name}" eliminata correttamente`)
};

const ru_preset_manager_delete_success_toast = /** @type {(inputs: Preset_Manager_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Предварительно заданные параметры "${i?.name}" успешно удалены.`)
};

const es_preset_manager_delete_success_toast = /** @type {(inputs: Preset_Manager_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preset "${i?.name}" eliminado exitosamente`)
};

const zh_cn2_preset_manager_delete_success_toast = /** @type {(inputs: Preset_Manager_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`预设“${i?.name}”已成功删除`)
};

const ja_preset_manager_delete_success_toast = /** @type {(inputs: Preset_Manager_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プリセット「${i?.name}」が正常に削除されました`)
};

const hi_preset_manager_delete_success_toast = /** @type {(inputs: Preset_Manager_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रीसेट "${i?.name}" सफलतापूर्वक हटा दिया गया`)
};

const pt_pt2_preset_manager_delete_success_toast = /** @type {(inputs: Preset_Manager_Delete_Success_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Predefinição "${i?.name}" excluída com sucesso`)
};

/**
* | output |
* | --- |
* | "Preset \"{name}\" deleted successfully" |
*
* @param {Preset_Manager_Delete_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_delete_success_toast = /** @type {((inputs: Preset_Manager_Delete_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Delete_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_delete_success_toast(inputs)
	if (locale === "de") return de_preset_manager_delete_success_toast(inputs)
	if (locale === "it") return it_preset_manager_delete_success_toast(inputs)
	if (locale === "ru") return ru_preset_manager_delete_success_toast(inputs)
	if (locale === "es") return es_preset_manager_delete_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_delete_success_toast(inputs)
	if (locale === "ja") return ja_preset_manager_delete_success_toast(inputs)
	if (locale === "hi") return hi_preset_manager_delete_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_delete_success_toast(inputs)
	return en_preset_manager_delete_success_toast(inputs)
});